import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import QRCode from "react-qr-code";
import api from "../../services/api";
import { useAuth } from "../../hooks/auth";

export const GenerateQRCode = () => {
  const {cookies} = useAuth()
  const [digitalTicket, setDigitalTicket] = useState("");

  const handleGetTicket = async (email) => {
    try {
      const response = await api.get("/key/code", {
        headers: {
          Authorization: `Bearer ${cookies.data.token}`
        },
        params: {
          email: email
        }// Use the params variable directly without an object wrapper
      });
      console.log(response.data);
      if (response) {
        setDigitalTicket(response.data.code);
        // Do something with response data, like update state
      }
    } catch (error) {
      console.error(error);
    }
  };
  

  useEffect(() => {
    handleGetTicket(cookies.data.email);
  }, []);

  return (
    <Box
      sx={{
        height: "auto",
        margin: "0 auto",
        maxWidth: 220,
        width: "100%",
        padding: "15px",
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
      <QRCode
        size={256}
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        value={digitalTicket}
        viewBox={`0 0 256 256`}
      />
    </Box>
  );
};
